import React from 'react'
import Summer from './Summer'
import Winter from './Winter'
import Weather from './Weather'
import './CustomPlot.css'

function fixFloat (n) {
  if (n !== n || (Math.abs(n) > 0.00001 && !n)) return ''
  else return n.toFixed(1)
}

function fixInt (n) {
  if (n !== n || (Math.abs(n) > 0.00001 && !n)) return ''
  else return n
}

export default class CustomPlot extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    const data = this.props.data

    const cleanData = {}

    cleanData.externalHumidity = fixInt(parseInt(data['external-humidity']))
    cleanData.externalTemp = fixInt(parseInt(data['external-temp']))
    cleanData.internalHumidity = fixInt(parseInt(data['global-humidity']))
    cleanData.internalTemp = fixInt(parseInt(data['global-temp']))

    cleanData.batteryPercentege = parseInt(data['PercentBattery'])
    cleanData.batteryPower = fixFloat(Math.abs(parseFloat(data['PowerBatt'])))
    cleanData.batteryRecharging = cleanData.batteryPower != parseFloat(data['PowerBatt'])

    cleanData.solarPower = fixFloat(parseFloat(data['PowerPV']))
    cleanData.cloudsCoverage = parseInt(data['clouds-coverage'])
    cleanData.houseConsumption = fixFloat(parseFloat(data['PowerHouse']))

    cleanData.daynight = data['daynight']
    cleanData.cloudsCoverage = parseInt(data['clouds-coverage'])
    cleanData.season = data['season']

    return (
      <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' viewBox='0 0 1463.64 914.77'>
        <defs>
          <linearGradient id='Sfumatura_senza_nome_3' x1='-11153.42' y1='10099.36' x2='11944.24' y2='-9369.01' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#fff' />
            <stop offset='0.22' stopColor='#fff' stopOpacity='0.76' />
            <stop offset='0.6' stopColor='#fff' stopOpacity='0.36' />
            <stop offset='0.87' stopColor='#fff' stopOpacity='0.1' />
            <stop offset='1' stopColor='#fff' stopOpacity='0' />
          </linearGradient>
          <linearGradient id='Sfumatura_senza_nome_3-2' x1='-22609.83' y1='20115.27' x2='24041' y2='-19205.41' xlinkHref='#Sfumatura_senza_nome_3' />
          <linearGradient id='Sfumatura_senza_nome_3-3' x1='-9422.46' y1='8818.41' x2='10143.09' y2='-7672.85' xlinkHref='#Sfumatura_senza_nome_3' />
          <linearGradient id='Sfumatura_senza_nome_3-4' x1='-47166.69' y1='41113.6' x2='48223.65' y2='-39288.24' xlinkHref='#Sfumatura_senza_nome_3' />
          <radialGradient id='Sfumatura_senza_nome_19' cx='345.07' cy='566.52' r='12.29' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#ff1d25' stopOpacity='0.3' />
            <stop offset='0.24' stopColor='#ff1d25' stopOpacity='0.4' />
            <stop offset='0.51' stopColor='#ff1d25' stopOpacity='0.5' />
            <stop offset='1' stopColor='#ff1d25' />
          </radialGradient>
          <radialGradient id='Sfumatura_senza_nome_19-2' cx='345.07' cy='485.27' r='12.29' xlinkHref='#Sfumatura_senza_nome_19' />
          <linearGradient id='Sfumatura_senza_nome_52' x1='981.06' y1='644.37' x2='1119.08' y2='644.37' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#ff1d25' />
            <stop offset='1' stopColor='#3fa9f5' />
          </linearGradient>
          <linearGradient id='Sfumatura_senza_nome_54' x1='981.06' y1='644.37' x2='1119.08' y2='644.37' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#fff' />
            <stop offset='1' stopColor='#3fa9f5' />
          </linearGradient>
          <radialGradient id='Sfumatura_senza_nome_32' cx='705.14' cy='229.26' r='48.4' xlinkHref='#Sfumatura_senza_nome_3' />
          <linearGradient id='Sfumatura_senza_nome_27' x1='-321.06' y1='686.82' x2='-303.59' y2='686.82' gradientTransform='matrix(-1, 0, 0, 1, 596.5, -14.71)' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#fff' />
            <stop offset='0.49' stopColor='#fff' stopOpacity='0.5' />
            <stop offset='0.76' stopColor='#fff' stopOpacity='0.4' />
            <stop offset='1' stopColor='#fff' stopOpacity='0.3' />
          </linearGradient>
          <linearGradient id='Sfumatura_senza_nome_27-2' x1='-289.56' y1='686.82' x2='-272.09' y2='686.82' xlinkHref='#Sfumatura_senza_nome_27' />
          <linearGradient id='Sfumatura_senza_nome_27-3' x1='-354.6' y1='686.82' x2='-337.12' y2='686.82' xlinkHref='#Sfumatura_senza_nome_27' />
          <linearGradient id='Sfumatura_senza_nome_60' x1='-321.06' y1='631.03' x2='-303.59' y2='631.03' gradientTransform='translate(1223.18 -14.71)' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#ff1d25' />
            <stop offset='0.49' stopColor='#ff1d25' stopOpacity='0.5' />
            <stop offset='0.76' stopColor='#ff1d25' stopOpacity='0.4' />
            <stop offset='1' stopColor='#ff1d25' stopOpacity='0.3' />
          </linearGradient>
          <linearGradient id='Sfumatura_senza_nome_60-2' x1='-289.56' y1='631.03' x2='-272.09' y2='631.03' xlinkHref='#Sfumatura_senza_nome_60' />
          <linearGradient id='Sfumatura_senza_nome_60-3' x1='-354.6' y1='631.03' x2='-337.12' y2='631.03' xlinkHref='#Sfumatura_senza_nome_60' />
          <linearGradient id='Sfumatura_senza_nome_50' x1='-40.94' y1='686.82' x2='-23.47' y2='686.82' gradientTransform='translate(1223.18 -14.71)' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#3fa9f5' />
            <stop offset='0.49' stopColor='#3fa9f5' stopOpacity='0.5' />
            <stop offset='0.77' stopColor='#3fa9f5' stopOpacity='0.4' />
            <stop offset='1' stopColor='#3fa9f5' stopOpacity='0.3' />
          </linearGradient>
          <linearGradient id='Sfumatura_senza_nome_50-2' x1='-9.44' y1='686.82' x2='8.03' y2='686.82' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_50-3' x1='-74.48' y1='686.82' x2='-57' y2='686.82' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_57' x1='-601.18' y1='631.03' x2='-583.71' y2='631.03' gradientTransform='matrix(-1, 0, 0, 1, 596.5, -14.71)' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_57-2' x1='-569.68' y1='631.03' x2='-552.21' y2='631.03' gradientTransform='matrix(-1, 0, 0, 1, 596.5, -14.71)' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_57-3' x1='-634.72' y1='631.03' x2='-617.24' y2='631.03' gradientTransform='matrix(-1, 0, 0, 1, 596.5, -14.71)' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_2' x1='981' y1='644.37' x2='1119.02' y2='644.37' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#fff' />
            <stop offset='1' stopColor='#ff1d25' />
          </linearGradient>
          <linearGradient id='Sfumatura_senza_nome_24' x1='981' y1='644.37' x2='1119.02' y2='644.37' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#3fa9f5' />
            <stop offset='1' stopColor='#ff931e' />
          </linearGradient>
          <linearGradient id='Sfumatura_senza_nome_7' x1='507.91' y1='512.91' x2='685.43' y2='512.91' xlinkHref='#Sfumatura_senza_nome_19' />
          <linearGradient id='Sfumatura_senza_nome_17' x1='700' y1='519.88' x2='1184.04' y2='519.88' gradientTransform='matrix(1, 0, 0, 1, 0, 0)' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_23' x1='258.85' y1='909.96' x2='276.33' y2='909.96' gradientTransform='translate(596.5 1303.14) rotate(180)' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#ff931e' />
            <stop offset='0.49' stopColor='#ff931e' stopOpacity='0.5' />
            <stop offset='0.76' stopColor='#ff931e' stopOpacity='0.4' />
            <stop offset='1' stopColor='#ff931e' stopOpacity='0.3' />
          </linearGradient>
          <linearGradient id='Sfumatura_senza_nome_33' x1='429.82' y1='861.08' x2='503.16' y2='861.08' gradientTransform='translate(-40.49 -467.89)' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#ff931e' stopOpacity='0.3' />
            <stop offset='0.24' stopColor='#ff931e' stopOpacity='0.4' />
            <stop offset='0.51' stopColor='#ff931e' stopOpacity='0.5' />
            <stop offset='1' stopColor='#ff931e' />
          </linearGradient>
          <linearGradient id='Sfumatura_senza_nome_33-2' x1='429.82' y1='612.91' x2='503.16' y2='612.91' gradientTransform='translate(-40.49 28.44)' xlinkHref='#Sfumatura_senza_nome_33' />
          <linearGradient id='Sfumatura_senza_nome_42' x1='-8.4' y1='789.11' x2='9.08' y2='789.11' gradientTransform='matrix(0, -1, -1, 0, 1969.32, 583.1)' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_39' x1='23.1' y1='789.11' x2='40.58' y2='789.11' gradientTransform='matrix(0, -1, -1, 0, 1969.32, 583.1)' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_27-7' x1='-321.06' y1='686.82' x2='-303.59' y2='686.82' gradientTransform='translate(596.5 1303.14) rotate(180)' xlinkHref='#Sfumatura_senza_nome_27' />
          <linearGradient id='Sfumatura_senza_nome_27-8' x1='-289.56' y1='686.82' x2='-272.09' y2='686.82' gradientTransform='translate(596.5 1303.14) rotate(180)' xlinkHref='#Sfumatura_senza_nome_27' />
          <linearGradient id='Sfumatura_senza_nome_27-9' x1='-354.6' y1='686.82' x2='-337.12' y2='686.82' gradientTransform='translate(596.5 1303.14) rotate(180)' xlinkHref='#Sfumatura_senza_nome_27' />
          <linearGradient id='Sfumatura_senza_nome_36' x1='-321.06' y1='631.03' x2='-303.59' y2='631.03' gradientTransform='matrix(1, 0, 0, -1, 1223.18, 1303.14)' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_36-2' x1='-289.56' y1='631.03' x2='-272.09' y2='631.03' gradientTransform='matrix(1, 0, 0, -1, 1223.18, 1303.14)' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_36-3' x1='-354.6' y1='631.03' x2='-337.12' y2='631.03' gradientTransform='matrix(1, 0, 0, -1, 1223.18, 1303.14)' xlinkHref='#Sfumatura_senza_nome_50' />
          <linearGradient id='Sfumatura_senza_nome_30' x1='-601.18' y1='631.03' x2='-583.71' y2='631.03' gradientTransform='translate(596.5 1303.14) rotate(180)' xlinkHref='#Sfumatura_senza_nome_60' />
          <linearGradient id='Sfumatura_senza_nome_30-2' x1='-569.68' y1='631.03' x2='-552.21' y2='631.03' gradientTransform='translate(596.5 1303.14) rotate(180)' xlinkHref='#Sfumatura_senza_nome_60' />
          <linearGradient id='Sfumatura_senza_nome_30-3' x1='-634.72' y1='631.03' x2='-617.24' y2='631.03' gradientTransform='translate(596.5 1303.14) rotate(180)' xlinkHref='#Sfumatura_senza_nome_60' />
        </defs>
        <g className='cls-1'>
          {
            data.season == 'summer'
              ? <Summer data={cleanData} />
              : <Winter data={cleanData} />
          }
          <Weather data={cleanData} />
        </g>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/CustomPlot/index.js